import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DeleteParameters } from '../models/DeleteParameters';
import { FormStatus } from '../models/Enums';


@Component({
    selector: "delete-confirm",
    templateUrl: "delete-confirm.component.html",
    styles: [],
    standalone: false
})
export class DeleteComponent {
    @Input() deleteItemParameters: DeleteParameters = new DeleteParameters();
    @Output() confirmEmitter = new EventEmitter<boolean>();
    @ViewChild("closeButton") closeButton;
    @Input() deleteFormId: string = 'deleteModal';

    readonly FormStatus = FormStatus;
    formStatus: FormStatus = FormStatus.Normal;
  
    ngOnit() {
    }

    confirm() {
        this.formStatus = FormStatus.Deleting;
        this.confirmEmitter.emit(true);
    }

    cancel() {
        this.formStatus = FormStatus.Normal;
    }

    close() {
        this.formStatus = FormStatus.Normal;
        this.closeButton.nativeElement.click();
    }
}
